import type { DonationSourceKey } from "@/lib/admin-api-types";

export const DONATION_SOURCE_KEYS: DonationSourceKey[] = [
  "individual",
  "corporate",
  "csr",
  "events",
  "online",
];

export const DONATION_SOURCE_LABELS: Record<DonationSourceKey, string> = {
  individual: "Individual Donors",
  corporate: "Corporate",
  csr: "CSR",
  events: "Events",
  online: "Online",
};

export const DONATION_SOURCE_COLORS: Record<DonationSourceKey, string> = {
  individual: "#1B7F4C",
  corporate: "#2D9B6A",
  csr: "#D9A441",
  events: "#6B7280",
  online: "#9CA3AF",
};

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

export function formatMonthKey(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function parseMonthKey(monthKey: string): { year: number; month: number } {
  const [yearStr, monthStr] = monthKey.split("-");
  return { year: Number(yearStr), month: Number(monthStr) };
}

export function formatMonthLabel(month: number): string {
  return MONTH_LABELS[month - 1] ?? String(month);
}

export function formatPeriodLabel(year: number, month: number | null): string {
  if (month === null) return "Year to date";
  const date = new Date(year, month - 1, 1);
  return date.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}
